/* Mana Forge theme scripts */
(function () {
  'use strict';

  /* ---------- Predictive search ---------- */
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');

  if (input && results) {
    var timer = null;
    var close = function () { results.classList.remove('is-open'); results.innerHTML = ''; };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="search__result"><span class="muted">No cards found for "' + q.replace(/</g, '&lt;') + '"</span></div>';
            } else {
              results.innerHTML = products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
                return '<a class="search__result" href="' + p.url + '">' + img +
                  '<span class="search__result-title">' + p.title + '</span>' +
                  '<span class="search__result-price">' + (p.price ? p.price : '') + '</span></a>';
              }).join('');
            }
            results.classList.add('is-open');
          })
          .catch(close);
      }, 180);
    });

    document.addEventListener('click', function (e) {
      if (!results.contains(e.target) && e.target !== input) close();
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Mobile filter drawer ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      var panel = document.querySelector('[data-facets]');
      if (panel) panel.classList.toggle('is-open');
    });
  }

  /* ---------- Auto-submit facet form ---------- */
  var facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      facetForm.submit();
    });
  }

  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var field = wrap.querySelector('input');
    var next = parseInt(field.value, 10) + parseInt(btn.dataset.qtyChange, 10);
    var min = parseInt(field.min || '1', 10);
    field.value = next < min ? min : next;
    field.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart line updates ---------- */
  document.addEventListener('change', function (e) {
    var field = e.target.closest('[data-cart-qty]');
    if (!field) return;
    updateCart(field.dataset.cartQty, field.value);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    updateCart(remove.dataset.cartRemove, 0);
  });

  function updateCart(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function () { window.location.reload(); });
  }

  /* ---------- Product variant selection ---------- */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-variant-id]');
      if (!pill) return;
      var id = pill.dataset.variantId;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.location.href = url.toString();
    });
  }
})();
